module.exports = __webpack_public_path__ + "img/check-circle.ccd2c75f.svg";